import React, { useState } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { isMobile } from 'react-device-detect';
import DatePicker from 'react-mobile-datepicker';
import Cleave from 'cleave.js/react';
import Text from '../../Common/Form/Text';
import Continue from '../../Common/Continue';
import { OptionGroup, OptionItem } from '../../ui';
import { setHealthValue, setPersonBirthdate } from '../../../actions';
import { useContinue } from './useContinue';
import { validateDate, stringToDate } from '../../../helpers';

const IconError = ({ size = 24, color = 'currentColor' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"></polygon>
    <line x1="15" y1="9" x2="9" y2="15"></line>
    <line x1="9" y1="9" x2="15" y2="15"></line>
  </svg>
);

const IconValid = ({ size = 24, color = 'currentColor' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
    <polyline points="22 4 12 14.01 9 11.01"></polyline>
  </svg>
);

const InputDateWrapper = styled.div`
  input {
    border: 1px solid transparent;
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0 7px 6px 0 rgba(0, 0, 0, 0.11), 0 2px 4px 0 rgba(0, 0, 0, 0.09);
    font-size: 15px;
    font-family: inherit;
    padding: 0.75em 1em;
    width: 100%;
    transition: box-shadow 0.35s ease;

    &:focus {
      box-shadow: 0 7px 6px 0 rgba(0, 51, 160, 0.11),
        0 2px 4px 0 rgba(0, 51, 160, 0.09);
    }
  }
`;

const SaludForm3 = ({
  personGender,
  personBirthdate,
  personAge,
  onValueChange,
  onBirthdateSelect
}) => {
  const [showDatePicker, setShowDatePicker] = useState(false);

  function isValidPersonBirthdate(personBirthdate) {
    return (
      personBirthdate !== '' &&
      validateDate(personBirthdate) &&
      personAge >= 18 &&
      personAge <= 65
    );
  }

  const isValidForm = useContinue(
    personGender && isValidPersonBirthdate(personBirthdate)
  );

  function handleSelectBirthdate(birthdate) {
    onBirthdateSelect(birthdate.ddmmyyyy());
    setShowDatePicker(!showDatePicker);
  }

  return (
    <div>
      <div className="Question-Grid-Container">
        <div className="Question-Grid-Data-Container">
          <Text className="Text-question" style={{ marginBottom: 20 }}>
            Selecciona tu sexo
          </Text>

          <OptionGroup>
            <OptionItem
              active={personGender === 'M'}
              onClick={() => onValueChange('personGender', 'M')}
            >
              Masculino
            </OptionItem>

            <OptionItem
              active={personGender === 'F'}
              onClick={() => onValueChange('personGender', 'F')}
            >
              Femenino
            </OptionItem>
          </OptionGroup>

          <Text className="Text-question" style={{ marginBottom: 20 }}>
            ¿Cuál es tu fecha de nacimiento?
          </Text>

          <div
            style={{ maxWidth: 400, marginLeft: 'auto', marginRight: 'auto' }}
          >
            <InputDateWrapper>
              <div
                onClick={() => {
                  if (!showDatePicker) setShowDatePicker(!showDatePicker);
                }}
              >
                {/*DATE PICKER*/
                (isMobile &&
                  !showDatePicker &&
                  (personBirthdate === '' ? (
                    <div className="Text-PlaceHolder">DD/MM/AAAA</div>
                  ) : (
                    <div className="Text">{personBirthdate}</div>
                  ))) ||
                  (isMobile && showDatePicker && (
                    <DatePicker
                      isPopup={false}
                      value={
                        personBirthdate !== ''
                          ? stringToDate(personBirthdate)
                          : new Date(1990, 0, 1)
                      }
                      isOpen={showDatePicker}
                      onSelect={handleSelectBirthdate}
                      onCancel={() => setShowDatePicker(!showDatePicker)}
                      confirmText="Ok"
                      cancelText="Atrás"
                      dateFormat={['D', 'M', 'YYYY']}
                      showFormat="DD/MM/YYYY"
                      min={new Date(1900, 0, 1)}
                      max={new Date()}
                      showHeader={true}
                    />
                  )) ||
                  /*DATE INPUT*/
                  (!isMobile && (
                    <Cleave
                      name="birthday"
                      placeholder="DD/MM/AAAA"
                      className="Text-Cleave"
                      value={personBirthdate}
                      options={{ date: true, datePattern: ['d', 'm', 'Y'] }}
                      onChange={event => onBirthdateSelect(event.target.value)}
                    />
                  ))}
              </div>
            </InputDateWrapper>

            <div
              style={{
                color:
                  personAge === '' ||
                  personAge === 0 ||
                  (personAge >= 18 && personAge <= 65)
                    ? '#666'
                    : 'firebrick',
                fontSize: 13,
                marginTop: 10,
                display: 'flex',
                alignItems: 'center'
              }}
            >
              {(personAge !== '' || personAge !== 0) &&
              personAge >= 18 &&
              personAge <= 65 ? (
                <IconValid size={18} color="green" />
              ) : (
                <IconError size={18} color="firebrick" />
              )}
              <span style={{ marginLeft: 6 }}>
                Edad de contratación de 18 a 64 años
              </span>
            </div>
          </div>
        </div>
      </div>

      <Continue state={isValidForm} />
    </div>
  );
};

const mapStateToProps = state => {
  return {
    personGender: state.health.personGender,
    personBirthdate: state.health.personBirthdate,
    personAge: state.health.personAge
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onValueChange: (type, value) => {
      dispatch(setHealthValue(type, value));
    },
    onBirthdateSelect: value => {
      dispatch(setPersonBirthdate(value));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SaludForm3);
